import React from 'react';
import propTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	root: {
		background: theme.palette.grey[100],
		color: theme.palette.grey[900],
		borderRadius: theme.spacing(1),
		paddingRight: theme.spacing(1),
		whiteSpace: 'nowrap',
		overflow: 'hidden',
	},
	avatar: {
		display: 'inline-block',
		height: '3.5em',
		width: '3.5em',
		borderRadius: '100%',
	},
	content: {
		display: 'inline-block',
	},
	title: {
		fontSize: '1.5em',
		whiteSpace: 'nowrap',
	},
	body: {
		fontSize: '1em',
		whiteSpace: 'nowrap',
	},
}));

export default function ItemCard(props) {
	const {
		className,
		avatarUrl,
		title,
		body,
	} = props;

	const classes = useStyles();

	return (
		<div className={clsx(classes.root, className)}>
			{avatarUrl && (
				<div
					className={classes.avatar}
					style={{
						backgroundImage: `url(${avatarUrl})`,
						backgroundSize: 'contain',
					}}
				/>
			)}
			<div className={classes.content}>
				<div className={classes.title}>{title}</div>
				<div className={classes.body}>{body}</div>
			</div>
		</div>
	);
}

ItemCard.defaultProps = {
	className: undefined,
	avatarUrl: undefined,
	title: '',
	body: '',
};

ItemCard.propTypes = {
	className: propTypes.string,
	avatarUrl: propTypes.string,
	title: propTypes.string,
	body: propTypes.string,
};
